
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/skianlegg",
      function () {
        return require("private-next-pages/[region]/[resort]/skianlegg.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/skianlegg"])
      });
    }
  